import React from "react";
import { Truncate } from "../../lib/Truncate";
import { FaIcon } from "../../lib/FaIcon";
import { gotoSearchResultsPage } from "../../api/search/filterUrlMaker";
import { useDispatch } from "react-redux";
import { miscSlice } from "redux/slices/miscSlice";
import "./tile.css";
import { populatePills, PillList } from "../ListView/PublicationItems";
import { getReferer } from "lib/routing";
import { HTMLComponent } from "lib/HTMLComponent";
import { truncate } from "lib/utils";
import { _t } from "app/i18n/i18n";
import { auditFeatureReportClick } from "../../lib/analytics/auditEvents";

export const Analysts = ({ analysts = [], lang, styles }) => (
  <Truncate show={7} more={7}>
    {analysts
      .filter((analyst) => analyst.isActive && analyst.isPrimary)
      .map((analyst, key) => (
        <small
          key={key}
          onClick={() => gotoSearchResultsPage("Analyst" + (lang === "ja" ? "-JA" : ""), analyst.name[lang])}
        >
          <b className={`${styles.analyst} text-uppercase font-weight-normal cursor-pointer`}>
            {key > 0 && ", "}
            {analyst.name[lang]}
          </b>
        </small>
      ))}
  </Truncate>
);

export const Title = ({ title = "", pubUrl = "", Highlight = "", id = 0, cardType, isFeaturedReport = false }) => {
  if (cardType === "podcast") return <PodcastTitle title={title} PubUrl={pubUrl} />;
  return (
    // eslint-disable-next-line react/jsx-no-target-blank
    <a
      href={pubUrl}
      target={id}
      rel="noopener"
      onClick={() => isFeaturedReport && id && auditFeatureReportClick(id)}
      // eslint-disable-next-line react/no-unknown-property
      referer={getReferer()}
      referrerPolicy="no-referrer-when-downgrade"
      className={"d-block font-weight-lighter h4 my-0 "}
    >
      {Highlight?.title ? (
        <HighlightText text={Highlight.title.toString()} className={Highlight.colour + " d-inline"} />
      ) : (
        title
      )}
    </a>
  );
};

export const FileTypeIcon = ({ resources, reportTypes, htmlUrl }) => {
  // don't show both pdf and html when both are available, only show pdf when not accompanied by html
  const shouldShowPDF = isPDFReport(resources) && !htmlUrl;

  return (
    <>
      {shouldShowPDF ? <i className={"fa-fw far fa-file-pdf file-icon"} data-title={`PDF`} /> : null}
      {isExcelFile(resources) ? <i className={"fa-fw far fa-file-excel file-icon"} data-title={`Excel`} /> : null}
      {isPodcast(reportTypes) ? (
        <i className={"fa-fw far fa-play-circle file-icon"} data-title={`${_t("Podcast")}`} />
      ) : null}
      {isWebcast(reportTypes) ? (
        <i className={"fa-fw far fa-file-video file-icon"} data-title={`${_t("Webcast")}`} />
      ) : null}
    </>
  );
};
export const Synopsis = ({ synopsis = "", Highlight = "", styles }) =>
  Highlight?.content ? (
    <HighlightText text={Highlight.content.toString()} className={Highlight.colour} />
  ) : (
    <section className="synopsis line-clamp-5">
      <div className={styles.synopsis || ""} />
      {truncate(synopsis, 300)}
    </section>
  );

export const Tags = (props) => {
  return (
    <div>
      <PillList pills={populatePills(props)} />
    </div>
  );
};

export const PublicationDate = ({ publicationDateLocale }) => (
  <small>
    <b>{publicationDateLocale} </b>
  </small>
);

export function MinutesRead({ wordCount }) {
  const minRead = wordCount > 0 && Math.floor(wordCount / 225) >= 1 ? Math.floor(wordCount / 225) : 1;
  return (
    <small>
      <b>{minRead} MIN READ | </b>
    </small>
  );
}

export const TopStory = () => (
  <span className="text-warning">
    <FaIcon icon="fas fa-medal fa-2x" />
    <small>
      <b>TOP STORY</b>
    </small>
    <br />
  </span>
);

const PodcastTitle = ({ title, PubUrl }) => {
  const dispatch = useDispatch();
  const onClick = () => dispatch(miscSlice.actions.set({ key: "podcastUrl", value: PubUrl }));

  return (
    <a href="#p" onClick={onClick} className="font-weight-lighter h3 my-0">
      <PlayIcon />
      {title}
    </a>
  );
};

export const HighlightText = ({ text, className }) => <HTMLComponent html={text} className={className} />;
const PlayIcon = () => <FaIcon icon="fa-fw far fa-play-circle fa-2x align-middle float-left" />;

const isPodcast = (reportTypes = []) =>
  reportTypes.filter((res) => res && (res.en === "Podcast" || res.jp === "Podcast")).length > 0;
const isWebcast = (reportTypes = []) =>
  reportTypes.filter((res) => res && (res.en === "Webcast" || res.jp === "Webcast")).length > 0;
const isPDFReport = (resources = []) => resources.filter((res) => res.extension && res.extension === ".pdf").length > 0;
const isExcelFile = (resources = []) =>
  resources.filter((res) => res.extension && res.extension === ".xlsx").length > 0;
